import { appRouter } from './appRouter';

export default async () => {

  console.debug('Start router', window.location.href);
  appRouter();

};
